const videoPlayerStyles = {
  container: {
    position: "relative",
    width: "100%",
    height: 400,
    backgroundColor: "#121212",
  },
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
  },
  video: {
    position: "absolute",
    top: "0",
    left: "0",
  },
  videoPlayerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "88%",
    zIndex: 1,
    cursor: "pointer",
    background: "transparent",
     "@media (max-width: 600px)": {
        height: '80%'
      }
  }
};

export default videoPlayerStyles;
